import { FragmentType, useFragment } from "@/gql"
import { MyJobActionButtonsFragmentDoc } from "@/gql/graphql"
import { FC } from "react"
import { determineJobPostingAction } from "../../utilts"
import { getAction } from "./MyJobActions"
import type { NovaSession } from "@/types"

export interface Props {
  jobPosting: FragmentType<typeof MyJobActionButtonsFragmentDoc> | null | undefined
  serverSession: NovaSession
}

export const MyJobActionsMobile: FC<Props> = props => {
  const jobPosting = useFragment(MyJobActionButtonsFragmentDoc, props.jobPosting)
  const jobStatus = determineJobPostingAction(jobPosting)
  const jobAction = getAction(jobStatus, jobPosting, props.serverSession)

  return <div className="mt-6 flex w-full flex-col md:hidden">{jobAction}</div>
}
